import React from "react";
import { BageType } from "../lib/types/bage-type";
import "../lib/index.css";


export function Bage({bageType, children, bagePin=true} : BageType) {
    return (
        <div className={`bage ${bageType ?? {}}`}>
            { bagePin && <div className={`pin ${bageType ?? {}}`}/> }
            {children}
        </div>
    )
}